/*
  Formatiranje za nadzornu ploču.

  Iz ranije verzije su ispale oznake paketa i statusa naplate — radile su na izmišljenom
  cjeniku u pregledniku (`PACKAGE_CONFIG`) i lažnim računima pretplate. Paketa više nema;
  klijent sjedi na kombinaciji packova, a naplata dolazi iz stvarnih pretplata.
*/

/** EUR bez decimala za velike agregate (KPI kartice). */
export const eur0 = (value: number): string =>
  new Intl.NumberFormat("hr-HR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(value);

/** Cijeli broj s tisućicama. */
export const num = (value: number): string =>
  new Intl.NumberFormat("hr-HR").format(value);

/**
 * Čitljiv naziv kombinacije packova: `vozilo.core+prodaja` → „Core + Prodaja".
 *
 * Ključ se ne razlaže nigdje drugdje u pregledniku — ovo je samo prikaz, cijena i dalje
 * dolazi iz resolvera.
 */
export const combinationLabel = (keyCode: string): string =>
  keyCode
    .replace(/^vozilo\./, "")
    .split("+")
    .map((code) => code.charAt(0).toUpperCase() + code.slice(1))
    .join(" + ");

/** Mjesec „2026-08-01" → „08/2026" za os grafa. */
export const monthLabel = (iso: string): string => {
  const date = new Date(iso);

  return `${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
};

/** „prije X" relativni prikaz iz ISO datuma. */
export const timeAgo = (iso: string | null): string => {
  if (!iso) return "—";

  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);

  if (mins < 60) return `prije ${mins} min`;

  const hours = Math.floor(mins / 60);

  if (hours < 24) return `prije ${hours} h`;

  const days = Math.floor(hours / 24);

  return `prije ${days} d`;
};
